import { getQueryParam } from "@/react/helpers/urlHelpers";
import type { CheckoutProps } from "../CheckoutProps";
import { getPaywallPrice } from "../helpers/paywallPrices";

export const useCheckoutPaywallPrice = ({ paywall }: CheckoutProps) => {
  let paywallPriceId: number | undefined;

  const queryPaywallPriceId = getQueryParam("price_id");
  if (queryPaywallPriceId) {
    const parsed = parseInt(queryPaywallPriceId, 10);
    if (!isNaN(parsed)) {
      paywallPriceId = parsed;
    }
  }

  return getPaywallPrice(paywall, paywallPriceId);
};
